import ChangeLanguageForm from './ChangeLanguageForm'

export default ChangeLanguageForm
